module.exports = __webpack_public_path__ + "img/signbg.e502eb6c.jpg";